import React from "react";
import Typography from "@mui/material/Typography";
import { useMyGames } from "@seabrookstudios/pitch2table";
import { GamesListFilters } from "@seabrookstudios/pitch2table-core";
import { ListView } from "../core/ListView";
import { ListDetail } from "../web/ListDetail";
import { GameDetailFromRoute } from "./GameDetail";
import { NoItemsFound } from "../publisher/NoItemsFound";
import AddGameFullScreenDialog from "./AddGameFullScreenDialog";
import { FilterList } from "../core/FilterList";
import { useFiltersv2 } from "../core/useFilters";
import { GameLifecycleTableDisplay } from "./GameLifecycleTableDisplay";

const NoGamesForTableView = () => (
  <NoItemsFound>
    <Typography align="center">No games found.</Typography>
  </NoItemsFound>
);

const CustomWebFilters = GamesListFilters.filter((filter) => filter.label !== "DUE");

const GamesLifecycleListView = () => {
  const gamesQuery = useMyGames();
  const { isLoading, isRefetching, isError, refetch } = gamesQuery;

  const filterConfiguration = useFiltersv2(gamesQuery, CustomWebFilters, "games");

  return (
    <ListView
      title="My Games"
      shown={filterConfiguration.filtered.length}
      isLoading={isLoading}
      isRefetching={isRefetching}
      isError={isError}
      refetch={refetch}
      EmptyList={NoGamesForTableView}
      Action={AddGameFullScreenDialog}
      Filters={() => (
        <FilterList
          filters={/** @type {any} */ (filterConfiguration.visibleFilters)}
          filter={filterConfiguration.filter}
          onFilterClicked={filterConfiguration.onFilterClicked}
        />
      )}
    >
      <GameLifecycleTableDisplay games={filterConfiguration.filtered} />
    </ListView>
  );
};

export const GamesLifecycleListAndDetail = () => {
  return <ListDetail ListView={GamesLifecycleListView} DetailView={GameDetailFromRoute} />;
};
